const requireModule = require.context('.', true, /.+/)
const modules = {}

requireModule
  .keys()
  .map(fileName => fileName.split('/')[1])
  .filter(x => x && !x.match(/^index|\.vue$/))
  .forEach(fileName => {
    modules[fileName] = requireModule('./' + fileName).default
  })

export default modules
